import { useQuery } from '@tanstack/react-query';

import {
  FormattedSearchResult,
  UnionMultiSearchResult,
  Hit,
  ActionDocument,
} from './search.types';
import { useGetTypeSenseAPIKeys } from '../../REST/typeSenseAPIKeys';
import { TypesenseCollection } from '../types';
import { typesense } from '../typesenseClient';

export const useGetAllActions = (enabled: boolean) => {
  const { data: apiKeys, isError: isKeyError } = useGetTypeSenseAPIKeys();

  const collectionApiKey =
    apiKeys?.[TypesenseCollection.ACTIONS.keyName]?.key ?? null;

  const hasActionsRights = !!collectionApiKey;

  const query = useQuery({
    queryKey: ['all-actions', collectionApiKey],
    queryFn: async () => {
      const searchRequest = {
        searches: [
          {
            collection: TypesenseCollection.ACTIONS.name,
            'x-typesense-api-key': collectionApiKey!,
            q: '*',
            query_by: 'Name',
            per_page: 5,
            sort_by: 'Order:asc',
          },
        ],
      };

      const multiSearchResults =
        await typesense.multiSearch.perform(searchRequest);

      const searchResult = multiSearchResults
        .results?.[0] as UnionMultiSearchResult;

      if (!searchResult?.hits) {
        return [];
      }

      return searchResult.hits.map(
        (hit: Hit): FormattedSearchResult => ({
          ...hit.document,
          highlightedProperties: [],
          pageUrl: (hit.document as ActionDocument).Url || '',
          score: 1,
          documentType: TypesenseCollection.ACTIONS.name,
          raw: hit,
        }),
      );
    },
    enabled: enabled && hasActionsRights && !isKeyError,
  });

  return {
    ...query,
    hasActionsRights,
  };
};
